import * as angular from 'angular';

export class GoogleMapService {
    static $inject = ['$q', 'googleMapsAPIKey', '$translate'];

    private window: Window & any = window;

    constructor(
        private $q: ng.IQService,
        private apiKey: string,
        private $translate: angular.translate.ITranslateService
    ) { }

    getGoogleMaps() {
        // Create a Deferred Object
        var deferred = this.$q.defer();
        var now = $.now();
        var version = '3';
        // Declare a resolve function, pass google.maps for the done functions
        var resolve = () => {
            if (this.window.google && this.window.google.maps) {
                deferred.resolve(this.window.google.maps);
            } else {
                let reason = this.$translate.instant('error_loading_google_maps');
                deferred.reject(reason);
            }
        };
        // global callback name
        var callbackName = 'loadGoogleMaps_' + (now++);
        // Default Parameters
        var params = $.extend(
            { 'v': version },
            { 'sensor': false },
            { 'key': this.apiKey },
            { 'language': 'en' },
            { 'libraries': 'geometry' }
        );
        // If google.maps exists, then Google Maps API was probably loaded with the <script> tag
        if (this.window.google && this.window.google.maps) {
            resolve();
            // If the google.load method exists, lets load the Google Maps API in Async.
        } else if (this.window.google && this.window.google.load) {
            this.window.google.load('maps', version, { 'other_params': $.param(params), 'callback': resolve });
            // Last, try pure jQuery Ajax technique to load the Google Maps API in Async.
        } else {
            // Ajax URL params
            params = $.extend(params, {
                'callback': callbackName
            });

            // Declare the global callback
            window[callbackName] = function () {
                resolve();
                // Delete callback
                setTimeout(function () {
                    try {
                        delete window[callbackName];
                    } catch (e) {
                        console.warn('delete callback function error', e);
                     }
                }, 20);
            };

            // Can't use the jXHR promise because 'script' doesn't support 'callback=?'
            $.ajax({
                dataType: 'script',
                data: params,
                url: 'https://maps.google.com/maps/api/js'
            });
        }

        return deferred.promise;
    }
}

angular.module('app.common').service('googleMapService', GoogleMapService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/google-map.service.ts